import { mount } from "svelte";
import App from "@buhl_ui/buhl_core/bc_news/joboffercards/App.svelte";

// const targetEl = document.getElementById("bc-job-offer-cards-root");

// mount(App, {target: targetEl, props: {legalTexts}});

document.querySelectorAll(".bc-job-offer-cards-root").forEach((el) => {
    // const legalTexts = {
    //     projectName: el?.dataset?.projectName ?? "",
    // };

    mount(App, { target: el, props: { layout: el.dataset.layout, projectName: el.dataset.projectName } });
});
